@if (store.loadError()) {
  <wf-alert-message
    class="wf-peppol-detail-dialog__error"
    type="error"
    [title]="'BasicErrorHandlerService_DefaultErrorTitle' | translate"
    [text]="loadErrorText().key | translate: { code: loadErrorText().code }"
  />
} @else if (store.loading()) {
  <wui-skeleton fill class="wf-peppol-detail-dialog__skeleton" />
  <wui-skeleton fill class="wf-peppol-detail-dialog__skeleton" />
} @else if (store.detail(); as detail) {
  <aside class="wf-peppol-detail-dialog__sections">
    @if (statusEvent(); as statusEvent) {
      <wf-peppol-detail-status
        [event]="statusEvent"
        [actions]="statusActions()"
        (actionSelected)="onStatusAction($event)"
      />
    }
    @if (!hideDocumentLink() && store.message(); as message) {
      <wf-peppol-detail-document-row
        [documentId]="message.documentId"
        [documentNumber]="documentPreview()?.number"
        [documentKind]="message.documentKind"
        (createDocumentRequested)="onCreateDocument()"
      />
    }
    <wf-peppol-detail-files
      [attachments]="store.attachments()"
      [activeFileName]="store.activeFileName()"
      (view)="onViewFile($event)"
      (download)="onDownloadFile($event)"
    />
    <wf-peppol-detail-sbdh [detail]="detail" />
    <wf-peppol-detail-raw-xml
      [content]="xmlAttachment()?.content ?? null"
      (showMore)="onShowRawXml()"
    />
  </aside>

  <section class="wf-peppol-detail-dialog__preview">
    <wf-peppol-detail-preview
      [detail]="detail"
      [ublPreview]="documentPreview()"
      [activeAttachment]="store.activeAttachment()"
    />
  </section>
}
